import { ChoiceButton } from "swing-components";

import type { ChoiceAnswerType } from "~onboarding/utils";

type ChoiceAnswerProps = Omit<ChoiceAnswerType, "type"> & {
  /**
   * The value of the answer. This is undefined when there is no answer.
   */
  value?: string;
  /**
   * When answering the Question, pass the `value` to the parent.
   */
  onChange: (value: string) => void;
  /**
   * Disables the editability of the answer.
   */
  isReadOnly?: boolean;
};

/**
 * Component | ChoiceAnswer
 *
 * Renders a list of choices used in SkillBuilder
 */
export function ChoiceAnswer(props: ChoiceAnswerProps) {
  const { value, onChange, isReadOnly, options } = props;

  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
        columnGap: 8,
      }}
    >
      {options.map((option) => (
        <div key={option.value} css={{ flex: 1 }}>
          <ChoiceButton
            icon={option.icon}
            isDisabled={isReadOnly}
            isSelected={value === option.value}
            onChange={onChange}
            label={option.label}
            value={option.value}
          />
        </div>
      ))}
    </div>
  );
}
